//参考年化
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { Big } = Util;
import XtSvg from "@/components/Xt/Svg";
import { Tooltip } from "antd";
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data, isCut, className }) => {
  const t = useTranslation();
  const { fund, finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      label: undefined,
      tip: undefined,
    };

    if (data.category === "STAKING" && data.productType === "LAUNCH_POOL") {
      convertData.label = finance.getYearlyProfitLaunchPool(data);
    } else if (data.category === "HASH_RATE") {
      //{【日最小/最大产量*（1-管理费率）/产品总量（份）】/（产品价格*申购币种价格/产品期限）} -1
      const label = finance.getYearlyProfitHashRate(data);
      if (!isCut || !label.includes("~")) {
        convertData.label = label;
      } else {
        const index = label.indexOf("~");
        const str = label.slice(index + 1).trim();

        convertData.label = str;
        convertData.tip = [label];
      }
    } else {
      if (!data.apyList) return convertData;

      if (data.profitType === "NORMAL") {
        convertData.label = Big(data.apyList[0].annualized || 0).toFixed(2) + "%";
      } else if (data.profitType === "GRADING") {
        const tip = [];
        let max = 0,
          // level = data.singleMin || 0;
          level = 0;
        data.apyList.map((obj, index) => {
          let str = t("finance.tier") + " " + (index + 1) + ": ";
          str +=
            (obj.level && obj.level > 0 ? level + " - " + obj.level : "> " + level) +
            " " +
            data.currency.toUpperCase() +
            " --> " +
            Big(obj.annualized || 0).toFixed(2) +
            "%";
          level = obj.level;
          max = Math.max(max, obj.annualized);
          tip.push(str);
        });
        convertData.label = Big(max || 0).toFixed(2) + "%";
        convertData.tip = tip;
      }
    }

    return convertData;
  }, [data, isCut, fund.assistPriceMap]);

  return (
    <div className={cx(styles.main, className)}>
      <span>{selfData.label}</span>
      {!!selfData.tip && (
        <Tooltip
          color={"rgba(0, 0, 0, 0.6)"}
          title={
            <div className={styles.tip}>
              {selfData.tip.map((str) => (
                <div>{str}</div>
              ))}
            </div>
          }
        >
          <span>
            <XtSvg icon={"warning"} />
          </span>
        </Tooltip>
      )}
    </div>
  );
});
